import * as Immutable from 'seamless-immutable';
import {DELETE_TEMPLATE_ID_SET} from '../actions';

const initialState = Immutable.from({
  templateId: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case DELETE_TEMPLATE_ID_SET:
      return state.merge({templateId: action.payload});
    default:
      return state;
  }
};
